module.exports = __webpack_public_path__ + "img/toux.d9fc02f7.png";